import { render } from "./RemoteMonitoringEventTile.vue?vue&type=template&id=61f2126c&ts=true"
import script from "./RemoteMonitoringEventTile.vue?vue&type=script&lang=ts"
export * from "./RemoteMonitoringEventTile.vue?vue&type=script&lang=ts"

import "./RemoteMonitoringEventTile.vue?vue&type=style&index=0&id=61f2126c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__